import { render, staticRenderFns } from "./Viajes.vue?vue&type=template&id=72375601&"
import script from "./Viajes.vue?vue&type=script&lang=js&"
export * from "./Viajes.vue?vue&type=script&lang=js&"
import style0 from "./Viajes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports